import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

/**
 * Type and spacing overrides for the deactivated block screen (ENG-1532), Figma node 2404:1683.
 *
 * Its own file rather than additions to `useTrialDashboardDesktopTypographyStyles`, because that
 * sheet is shared with the trial-expired and Sherwin screens and its `description` class is tuned
 * for their single `white-space: nowrap` line. This body wraps onto two lines.
 *
 * The whole screen is Euclid (the app's name for Euclid Circular A), not the Inter that
 * `Typography` defaults to — heading Semibold, body Medium, button Bold.
 */
export const useDeactivatedDashboardStyles = makeStyles((theme: Theme) => ({
  body: {
    // Figma: Euclid Circular A Medium, 20 / 25, tracking -0.4, brand/p35.
    fontFamily: 'Euclid',
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '25px',
    letterSpacing: '-0.4px',
    color: theme.paintscout.palette.brand.Neutral.P35,
    maxWidth: 744,
    // Figma puts ~32px between the last line of body copy and the top of the button.
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
      lineHeight: '21px',
      marginBottom: theme.spacing(3)
    }
  },
  button: {
    // Figma: 39.5px tall, 16px side padding — noticeably narrower than the shared trial button,
    // which pads 32px each side.
    fontFamily: 'Euclid',
    fontWeight: 700,
    fontSize: 15.36,
    lineHeight: '21.5px',
    padding: theme.spacing(1.25, 2),
    textTransform: 'none',
    alignSelf: 'flex-start',
    // The mobile layout centres its heading and body, so a left-aligned button reads as a
    // mistake. The shared trial button class pins flex-start, hence the explicit override.
    [theme.breakpoints.down('md')]: {
      alignSelf: 'center'
    }
  }
}))
